export const Proceso = Object.freeze({
  EXTRUSION: 30,
});
